<template>
  <div>
    <div class="flex NavTopLink">
      <div class="project flex">
        <div class="flex" style="flex: 1">
          <el-popover
            width="25%"
            trigger="click"
            :popper-style="{ padding: 0 }"
            v-model:visible="visible"
          >
            <div class="btn-popover">
              <el-row :gutter="10">
                <el-col
                  :span="12"
                  v-for="item in systemList"
                  :key="item.menuCode"
                >
                  <div
                    class="nav_btn"
                    :class="{ 'active-btn': subSystemId === item.menuCode }"
                    @click="clickSystem(item)"
                  >
                    <div class="logo"></div>
                    <div class="name">{{ item.menuName }}</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <template #reference>
              <div class="systemLogo">
                <img
                  src="../../../assets/images/gr-logo.png"
                  alt=""
                  srcset=""
                />
                {{ currentSubSystem }}
                <el-icon :size="15" style="margin-left: 10px"
                  ><Switch
                /></el-icon>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
      <div class="person_info">
        <!-- 小程序二维码 -->
        <div
          class="app_qrCode"
          :style="{ visibility: qrCodeShow ? '' : 'hidden' }"
        >
          <div class="app_qrCode_title">运营平台小程序</div>
          <div class="app_qrCode_code">
            <el-image :src="require('@/assets/codeImg.jpg')" />
          </div>
          <div class="app_qrCode_tip">打开手机扫一扫, 进入小程序</div>
        </div>
        <div
          class="qrcode_img"
          v-on:mouseover="qrCodeShow = true"
          v-on:mouseleave="qrCodeShow = false"
          :style="{
            // 只有 库房 和 官网 显示小程序二维码
            visibility: ['1686990513326432256', '1683679191499186176'].includes(
              currentSystemId
            )
              ? ''
              : 'hidden',
          }"
        ></div>
        <div class="flex">
          <messageCenter/>
        </div>
        <div class="flex" @mouseover="showUserInfo" @mouseleave="hideUserInfo">
          <el-avatar
            :size="24"
            v-if="userInfo.fileVO && userInfo.fileVO.path"
            :src="userInfo.fileVO && userInfo.fileVO.path"
          ></el-avatar>
          <el-button type="primary" size="small" circle v-else>
            {{
              userInfo
                ? userInfo.nikeName
                  ? userInfo.nikeName[0]
                  : userInfo.userName[0]
                : "管"
            }}</el-button
          >
          <div class="nickname">
            {{
              userInfo
                ? userInfo.nikeName
                  ? userInfo.nikeName
                  : userInfo.userName
                : "管理员"
            }}
          </div>
          <div :class="[isHover ? 'appear' : 'hide']">
            <div @click="gotoEntrance">入口菜单</div>
            <div @click="updatePassword">修改密码</div>
            <div @click="logout">安全退出</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    title="修改密码"
    width="30%"
    v-model="passwordVisible"
    :close-on-click-modal="false"
  >
    <el-form
      :model="passwordForm"
      ref="passwordRef"
      :rules="passwordRules"
      label-width="100px"
    >
      <el-form-item label="原密码：" prop="oldPassword">
        <el-input
          type="password"
          v-model="passwordForm.oldPassword"
          show-password
          :maxlength="16"
        />
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input
          type="password"
          v-model="passwordForm.newPassword"
          show-password
          :maxlength="16"
        />
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirmPassword">
        <el-input
          type="password"
          v-model="passwordForm.confirmPassword"
          show-password
          :maxlength="16"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span>
        <el-button type="primary" @click="passwordSubmit()">确认</el-button>
        <el-button @click="passwordVisible = false">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { ElMessage, ElMessageBox } from "element-plus";
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  getCurrentInstance,
  computed,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import svgIcon from "../../global/Common/svgIcon.vue";
import { getDarkColor, getLightColor } from "@/utils/color.js";
import { updatePasswordByPhoneNumber } from "@/api/userCenter";
import messageCenter from '../../message/messageCenter'
import CryptoJS from "@/utils/crypto.js";
export default defineComponent({
  components: { svgIcon, messageCenter },
  setup() {
    const qrCodeShow = ref(false);
    const currentSystemId = ref(sessionStorage.getItem("subSystemId"));
    const isDark = ref(false);
    const visible = ref(false);
    const passwordVisible = ref(false);
    const router = useRouter();
    const route = useRoute();
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const state = reactive({
      systemName: window.config.systemName ? window.config.systemName : null,
      isHover: false,
      systemList: [],
      primary: "#409EFF",
    });

    const userInfo = computed(() => store.getters.userInfo);
    const subSystemId = computed(() => store.getters.subSystemId);

    const logout = () => {
      ElMessageBox.confirm("是否退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          store.dispatch("userInfo/LogOut").then(() => {
            store.commit("permission/SET_SUB_SYSTEM_NAME", "");
            store.commit("permission/SET_ROUTE_TABS", []);
            store.commit("permission/SET_SUB_SYSTEM_ID", "");
            router.replace("/login");
          });
        })
        .catch(() => {});
    };

    // 修改密码
    const updatePassword = () => {
      passwordVisible.value = true;
      passwordForm.oldPassword = undefined;
      passwordForm.newPassword = undefined;
      passwordForm.confirmPassword = undefined;
    };

    const passwordForm = reactive({
      oldPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined,
    });

    const passwordRules = {
      oldPassword: [{ required: true, message: "请输入", trigger: "blur" }],
      newPassword: [
        { required: true, message: "请输入", trigger: "blur" },
        {
          validator: (rule, value, callback) => {
            if (value === passwordForm.oldPassword) {
              callback(new Error("新密码不能与原密码相同"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
      confirmPassword: [
        { required: true, message: "请输入", trigger: "blur" },
        {
          validator: (rule, value, callback) => {
            if (value !== passwordForm.newPassword) {
              callback(new Error("两次输入的不一致"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };

    const passwordSubmit = () => {
      proxy.$refs["passwordRef"].validate((valid) => {
        if (valid) {
          updatePasswordByPhoneNumber({
            passWord: CryptoJS.encryptWithHMAC(passwordForm.oldPassword),
            userName: userInfo.value.phone,
            newPassword: CryptoJS.encryptWithHMAC(passwordForm.newPassword),
          }).then((res) => {
            if (res.code == 2000) {
              passwordVisible.value = false;
              ElMessage.success("修改成功");
              store.dispatch("userInfo/LogOut").then(() => {
                store.commit("permission/SET_SUB_SYSTEM_NAME", "");
                store.commit("permission/SET_ROUTE_TABS", []);
                store.commit("permission/SET_SUB_SYSTEM_ID", "");
                router.replace("/login");
              });
            }
          });
        }
      });
    };

    // 前往入口
    const gotoEntrance = () => {
      router.replace("/entrance");
    };

    const showUserInfo = () => {
      state.isHover = true;
    };
    const hideUserInfo = () => {
      state.isHover = false;
    };
    const currentSubSystem = computed(() => {
      let name = state.systemList.find(
        (item) => item.menuCode === subSystemId.value
      );
      let result = name?.menuName ?? "智慧水务业务平台";
      return result;
    });
    onMounted(() => {
      subSystemId.value = sessionStorage.getItem("subSystemId");
      getSystemList();
    });

    const getSystemList = () => {
      state.systemList = [];
      if (store.getters.userInfo) {
        if (store.getters.userInfo.menuTree.length > 0) {
          if (store.getters.userInfo.menuTree[0].menuCode == "1") {
            state.systemList =
              store.getters.userInfo.menuTree[0]?.children ?? [];
          } else {
            store.getters.userInfo.menuTree.forEach((item) => {
              if (item.menuCode !== "1" && item.menuType.value === "M") {
                state.systemList.push(item);
              }
            });
          }
        }
        // 临时隐藏二次供水
        // state.systemList.push({
        //   menuCode: 1,
        //   menuName: "二次供水",
        // });
      } else {
        state.systemList = [];
      }

      // 使用reduce方法进行数组去重
      let uniqueSystemList = state.systemList.reduce((acc, current) => {
        const x = acc.find((item) => item.menuCode === current.menuCode);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      state.systemList = uniqueSystemList;
    };
    /** 点击系统 */
    const clickSystem = (sys) => {
      // 点击系统关闭选择框
      visible.value = false;
      if (sys.menuCode == 1) {
        window.open("http://192.168.2.241:11111/");
        return;
      }
      store.commit("permission/SET_SUB_SYSTEM_ID", sys.menuCode);
      sessionStorage.setItem("subSystemId", sys.menuCode);
    };
    /*换肤*/
    const changePrimary = (val) => {
      // 计算主题颜色变化
      document.documentElement.style.setProperty("--el-color-primary", val);
      document.documentElement.style.setProperty(
        "--el-color-primary-dark-2",
        isDark.value
          ? `${getLightColor(val, 0.2)}`
          : `${getDarkColor(val, 0.3)}`
      );
      for (let i = 1; i <= 9; i++) {
        const primaryColor = isDark.value
          ? `${getDarkColor(val, i / 10)}`
          : `${getLightColor(val, i / 10)}`;
        document.documentElement.style.setProperty(
          `--el-color-primary-light-${i}`,
          primaryColor
        );
      }
    };
    const colorList = [
      "#daa96e",
      "#0c819f",
      "#409eff",
      "#27ae60",
      "#ff5c93",
      "#e74c3c",
      "#fd726d",
      "#f39c12",
      "#9b59b6",
    ];
    return {
      ...toRefs(state),
      logout,
      userInfo,
      subSystemId,
      showUserInfo,
      hideUserInfo,
      clickSystem,
      colorList,
      changePrimary,
      visible,
      currentSubSystem,
      passwordVisible,
      passwordForm,
      passwordRules,
      gotoEntrance,
      updatePassword,
      passwordSubmit,
      qrCodeShow,
      currentSystemId,
    };
  },
});
</script>
<style lang="less" scoped>
.NavTopLink {
  width: 100%;
  height: 50px;
  justify-content: space-between;
  background-color: #31486e;
  .systemName {
    font-size: 16px;
  }
  .systemLogo {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 20px;
    font-size: 18px;
    height: 100%;
    > img {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
}

.project {
  // width: 200px;
  // width: 290px;
  height: 50px;
  align-items: center;
  justify-content: center;
  line-height: 50px;
  color: white;
  > .flex {
    align-items: center;
    justify-content: center;
  }
}
ul {
  list-style: none;
  // width: calc(100% - 800px);
  height: 50px;
  // padding: 0 0 0 24px;
  padding: 0;
  margin: 0;
  position: relative;
  flex: 1;
  li {
    &:hover {
      background-color: rgba(0, 0, 0, 0.08);
      color: white;
      cursor: pointer;
    }
    position: relative;
    width: 80px;
    cursor: pointer;
    height: 50px;
    // line-height: 50px;
    font-size: 16px;
    text-align: center;
  }
  .Active {
    width: 18%;
    display: inline-block;
    height: 1px;
    background-color: white;
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translate(-50%);
  }
  .navTopLink-normal {
    display: inline-block;
    height: 50px;
    line-height: 50px;
  }
  .suspended {
    display: none;
  }
  .show {
    display: inline-block;
    position: absolute;
    top: 50px;
    z-index: 999;
    left: 0px;
    // min-width: 600px;
    width: 860px;
    height: 560px;
    :deep(.application) {
      border-radius: 0 0 12px 6px;
      padding: 0 20px;
      overflow-y: auto;
      .title {
        height: 100%;
      }
      .applInfo {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        cursor: pointer;
        .applName {
          margin-bottom: 16px;
          div {
            flex: 1;
          }
        }
      }
    }
  }
  .popup {
    display: inline-block;
    position: fixed;
    top: 50px;
    z-index: 998;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.link {
  &::after {
    content: "";
    width: 1px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.75);
    margin-left: 16px;
  }
  // width: 400px;
  .linkEnterprise {
    &:hover {
      color: #e0d4d4;
      // transition: 1s;
    }
  }
}
.person_info {
  display: flex;
  align-items: center;
  // width: 200px;
  height: 50px;
  line-height: 50px;

  .systems {
    color: white;
    height: 100%;
    // width: 50px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-end;
    margin-right: 30px;
    &:hover {
      .systems-list {
        display: inline-block;
      }
    }
    .systems-list {
      display: none;
      position: absolute;
      top: 50px;
      width: 125px;
      background: white;
      right: 0;
      z-index: 10000;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px,
        rgba(0, 0, 0, 0.23) 0px 3px 6px;
      .systems-item {
        cursor: pointer;
        color: black;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        &.active {
          color: #409eff;
        }
        &:hover {
          color: #409eff;
        }
        .menuName {
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          overflow: hidden;
        }
      }
    }
  }

  > div {
    // width: 50%;
    text-align: center;
    &.msg-icon {
      width: 60px;
    }
  }
  > .flex {
    height: 50px;
    position: relative;
    padding-right: 10px;
  }
  .hide {
    display: none;
  }
  .appear {
    width: 100%;
    display: inline-block;
    position: absolute;
    top: 50px;
    left: 0;
    background-color: white;
    z-index: 10;
    color: black;
    font-size: 14px;
    > div {
      cursor: pointer;
      border-bottom: 1px solid white;
      &:last-child {
        border: none;
      }
    }
  }
}
.flex {
  align-items: center;
  cursor: pointer;
  .nickname {
    display: inline-block;
    padding: 0 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: white;
  }
}

.btn-popover {
  padding: 0 24px 24px 24px;
  .nav_btn {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    flex-shrink: 0;
    border-radius: 4px;
    border: 1px solid #fff;
    background: #fff;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 6px;

    .logo {
      width: 36px;
      height: 36px;
      background: url("../../../assets/images/navTop/logo.png");
      background-repeat: no-repeat;
    }

    .name {
      margin-left: 8px;
      max-width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover {
      cursor: pointer;
      color: #fff;
      border-radius: 4px;
      background: #3868bf;
      box-shadow: 0px 2px 20px 0px rgba(0, 17, 61, 0.1),
        0px 8px 6px 0px rgba(56, 104, 191, 0.1) inset;
    }
  }
  .active-btn {
    color: #fff;
    border-radius: 4px;
    background: #3868bf;
    box-shadow: 0px 2px 20px 0px rgba(0, 17, 61, 0.1),
      0px 8px 6px 0px rgba(56, 104, 191, 0.1) inset;
  }
}

.qrcode_img {
  cursor: pointer;
  height: 28px;
  width: 28px;
  background-image: url("../../../assets/blurQr.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-right: 10px;
}
.qrcode_img:hover {
  background-image: url("../../../assets/qrCode.png");
}

.app_qrCode {
  width: 260px;
  height: 260px;
  position: relative;
  top: 156px;
  left: 98px;
  border-radius: 8px;
  background: #31486e;
  z-index: 9999;

  .app_qrCode_title {
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-weight: 700;
    position: relative;
    top: 7%;
    text-align: center;
    color: #fff;
    font-weight: 700;
  }
  .app_qrCode_code {
    width: 180px;
    height: 180px;
    border-radius: 6px;
    position: relative;
    top: 15%;
    left: 10%;
    background: #31486e;
    z-index: 9999;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .app_qrCode_tip {
    width: 13px;
    height: 169px;
    color: #fff;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    position: relative;
    top: -55%;
    left: 86%;
  }
}
</style>
